<template>
  <div class="header">
    <router-view name="header"/>
  </div>
  <div class="app-main" id="main">
    <div class="side">
      <router-view name="side"/>
    </div>
    <div class="content">
      <router-view/>
    </div>
  </div>
</template>

<script setup lang="ts">

import {onUpdated} from "vue";

onUpdated(() => {
  document.getElementsByClassName('content').item(0)?.scrollTo(0, 0)
})
</script>

<style scoped lang="sass">
.header
  height: 70px
  background: white
  box-shadow: 0 5px 20px 0 rgba(32, 35, 87, .09)
  display: flex
  justify-content: space-between
  align-items: center
  z-index: 99

.app-main
  flex: 1
  display: flex
  flex-flow: row nowrap
  height: calc(100vh - 70px)

  :where(.css-dev-only-do-not-override-1p3hq3p).ant-drawer
    position: absolute

  > .side
    background: white
    box-shadow: 8px 10px 27px 0 rgba(32, 35, 87, .09)
    position: relative
    display: flex
    flex-direction: column
    transition: all .3s
    overflow-y: auto

    &::-webkit-scrollbar
      display: none

  > .content
    flex: 1
    overflow-y: auto
    overflow-x: hidden
</style>